import get from 'lodash/get'

/**
 * Given a list of elements, maps the name to the id.
 * This is a helper fn that can used for getting the filters summary.
 */
export function getDictionary<T>(elements: T[], idTag: string, nameTag: string) {
  return elements?.reduce((acc, el) => {
    const id = get(el, idTag)
    const name = get(el, nameTag)

    if (!id) return acc

    return {
      ...acc,
      [id]: name,
    }
  }, {} as Record<string, string>)
}
